// The File Browser and the video editor are separate blade pages, so a selection can only cross
// by storage plus a page load (the same trick as 'optix-lab-presets').
const STORAGE_KEY = 'video-import-files';
// AI Studio's "Create a video" (POR-14827): what the video page's New Project popup opens with.
const CREATE_STORAGE_KEY = 'video-create-request';
const MAX_AGE_MS = 5 * 60 * 1000;

function setPending(key, payload, label) {
  try {
    localStorage.setItem(key, JSON.stringify({ ...payload, createdAt: Date.now() }));

    return true;
  } catch (error) {
    console.error(label, error);

    return false;
  }
}

// A payload the video page never picked up must not act on its own days later.
function takePending(key, label) {
  let raw = null;

  try {
    raw = localStorage.getItem(key);
    localStorage.removeItem(key);
  } catch (error) {
    console.error(label, error);

    return null;
  }

  if (!raw) {
    return null;
  }

  try {
    const payload = JSON.parse(raw);

    return payload && Date.now() - payload.createdAt <= MAX_AGE_MS ? payload : null;
  } catch (error) {
    console.error(label, error);

    return null;
  }
}

export function setPendingVideoImport(items) {
  return setPending(STORAGE_KEY, { items }, '[setPendingVideoImport]');
}

export function takePendingVideoImport() {
  const payload = takePending(STORAGE_KEY, '[takePendingVideoImport]');

  return payload && Array.isArray(payload.items) ? payload.items : [];
}

/**
 * @param {{source: 'brief', briefId: string, briefTitle?: string}
 *   | {source: 'script', text: string}} request
 */
export function setPendingVideoCreate(request) {
  return setPending(CREATE_STORAGE_KEY, { request }, '[setPendingVideoCreate]');
}

export function takePendingVideoCreate() {
  const payload = takePending(CREATE_STORAGE_KEY, '[takePendingVideoCreate]');
  const request = payload && payload.request;

  if (request && request.source === 'brief' && request.briefId) {
    return request;
  }

  return request && request.source === 'script' && request.text ? request : null;
}
